import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface GroupProductOnboardingRequestDialogData {
  providerName: string;
  planName: string;
}

export interface GroupProductOnboardingRequestDialogResult {
  send: boolean;
  note: string;
}

@Component({
  selector: 'app-group-product-onboarding-request-dialog',
  templateUrl: './group-product-onboarding-request-dialog.component.html',
  styleUrls: ['./group-product-onboarding-request-dialog.component.scss'],
})
export class GroupProductOnboardingRequestDialogComponent {
  protected note = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: GroupProductOnboardingRequestDialogData,
    private dialogRef: MatDialogRef<
      GroupProductOnboardingRequestDialogComponent,
      GroupProductOnboardingRequestDialogResult
    >,
  ) {}

  protected cancel(): void {
    this.dialogRef.close({ send: false, note: '' });
  }

  protected send(): void {
    this.dialogRef.close({
      send: true,
      note: `${this.note || ''}`.trim(),
    });
  }
}
